import { Navigate, createBrowserRouter } from 'react-router-dom';

import { actionsRoutes } from '@/features/Actions';
import { dashboardRoutes } from '@/features/Dashboard';
import { notificationRoutes } from '@/features/Notifications';
import { organizationRoutes, organizationsListRoutes } from '@/features/Organization/routes';
import { tasksRoutes } from '@/features/Tasks';
import { AuthLayout } from '@/layouts/AuthLayout';
import { MainLayout } from '@/layouts/MainLayout';
import { NavigationLayout } from '@/layouts/NavigationLayout';
import { NotFoundLayout } from '@/layouts/NotFoundLayout';

const routes = createBrowserRouter([
	{
		element: <AuthLayout />,
		errorElement: <NotFoundLayout />,
		children: [
			{
				element: <NavigationLayout />,
				children: [
					{
						element: <MainLayout />,
						children: [
							{
								index: true,
								element: <Navigate to="/dashboard" replace={true} />,
							},
							...dashboardRoutes,
							...notificationRoutes,
							...tasksRoutes,
							...actionsRoutes,
							...organizationsListRoutes,
							{
								path: '*',
								element: <Navigate to="/" replace={true} />,
							},
						],
					},
				],
			},
			...organizationRoutes,
		],
	},
]);

export default routes;
